<template>
  <div class="alert-main">
    <transition name="opacity">
      <div class="cover" @click="close" v-if="alertData.show"></div>
    </transition>
    <!-- 全局性组件弹窗 -->
    <transition name="opacity">

      <!-- 简历模板 -->
      <div class="box template" v-if="alertData.show && alertData.type === 'template' && templates.length">

        <div class="menu-list">
          <template v-for="item in templates">
            <div v-if="!item.type" class="menu"  :key="item.title">

              <img :src="images[item.en]" alt="">
              <p class="title">{{item.cn}}</p>
              <p class="desc">{{item.temp_desc}}</p>

              <div class="btn">
                <button v-if="item.cn_img" @click="selectTemplate(item.en, item.cn_img, 'cn', item.cn_token)">中文模板</button>
                <button v-if="item.en_img" @click="selectTemplate(item.en, item.en_img, 'en', item.en_token)">英文模板</button>
              </div>

            </div>
          </template>
          
        </div>

        <div class="template-more-btn" @click="toMoreTemplateFunc()">查看更多简历模板</div>

      </div>

      <!-- gpa 弹窗 -->
      <div class="box gpa" v-if="alertData.show && alertData.type === 'gpa'">
        <i class="close iconfont iconx" @click="close"></i>
        <h4 class="title">GPA计算器</h4>
        <p class="msg">为了方便 HR 衡量候选人，推荐将成绩绩点转换为 4.0 国际标准。</p>
        <p class="msg">将你的绩点和学校的总分标准输入到下方框内。</p>
        <div class="case">
          <b>案例：</b>
          <p>1. 满分为 5.0，绩点为 3.75，在绩点框内输入 3.75，在总分框内输入 5.0；</p>
          <p>2. 满分为 100分，绩点为 87 分，在绩点框内输入 87，在总分框内输入 100。</p>
        </div>
        <div class="info">
          <input v-model="grade" type="text" placeholder="绩点">
          <input v-model="score" type="text" placeholder="总分">
          <button @click="transform">转换</button>
        </div>
        <div class="result" v-if="result">你的 GPA 是：<b>{{result.toFixed(2)}}</b></div>
      </div>

      <!-- 大牛简历 -->
      <div class="box applets" v-if="alertData.show && alertData.type === 'applets'">
        <div class="title">名企大牛简历分享</div>
        <img src="@/assets/image/sidebar/alert/applets.png" alt="">
        <div class="msg">微信扫码 立即查看</div>
      </div>

      <!-- up vip -->
      <pay-alert
        v-if="alertData.show && alertData.type === 'upVip'"
        :noBg="true"
        :origin="alertData.origin"
        :browseType="alertData.browseType"
        :displayContinueBtn="alertData.displayContinueBtn"
        :continueBtnText="alertData.continueBtnText"
        :dialogMemberConfigStr="alertData.dialogMemberConfigStr"
        @close="close"
        @downloadContinue="alertData.downloadContinue"
      />

      <!-- AI 写简历 -->
      <ComponentAiCvsDialog v-if="alertData.show && alertData.type === 'ai-cvs'" @close="close" />


<!--      <div class="box up-vip" data-growing-container v-if="alertData.show && alertData.type === 'upVip'" data-gio-imp-track="browseUpVip" :data-gio-imp-track-origin="alertData.browseType || 'cvs'">-->
<!--        -->
<!--        <img class="vip-bg" src="https://files.wondercv.com/block/VIPPopup.png" alt="">-->

<!--        <button class="vip-btn" @click="improvedOrder">立即升级</button>-->

<!--        &lt;!&ndash; <div class="title">-->
<!--          <div class="super-logo">-->
<!--            <img src="../../assets/image/super_logo.png" alt="">-->
<!--            <span>超级会员</span>-->
<!--          </div>-->
<!--          <p>尊享 7 大特权，求职路上畅通无阻</p>-->
<!--          <img class="vip-bg" src="https://files.wondercv.com/image/wip.png" alt="">-->
<!--        </div> &ndash;&gt;-->

<!--        &lt;!&ndash; <div class="content">-->

<!--          <div class="desc">-->
<!--            <div class="desc-left desc-item">-->
<!--              <h6 class="desc-title"><img src="https://files.wondercv.com/image/VIP%20icon.png" alt="">超级会员</h6>-->
<!--              <p class="desc-text"><i class="iconfont iconwanmei"></i>畅享 <span class="strong">15 份</span>简历</p>-->
<!--              <p class="desc-text"><i class="iconfont iconwanmei"></i>全站大厂简历模版<span class="strong">免费用</span></p>-->
<!--              <p class="desc-text"><i class="iconfont iconwanmei"></i><span class="strong">不限次数</span> AI 智能检查</p>-->
<!--              <p class="desc-text"><i class="iconfont iconwanmei"></i><span class="strong">一键</span>简历纠错</p>-->
<!--              <p class="desc-text"><i class="iconfont iconwanmei"></i><span class="strong">免费</span>制作证件照</p>-->
<!--              <p class="desc-text"><i class="iconfont iconwanmei"></i><span class="strong">无限</span>次简历中英互译</p>-->
<!--              <p class="desc-text"><i class="iconfont iconwanmei"></i>回收站简历 <span class="strong">360 天</span>可恢复</p>-->
<!--            </div>-->
<!--            <div class="desc-right desc-item">-->
<!--              <h6 class="desc-title">普通用户</h6>-->
<!--              <p class="desc-text">简历份数 1 份</p>-->
<!--              <p class="desc-text">可用部分免费模版</p>-->
<!--              <p class="desc-text">每天 1 次AI智能检查</p>-->
<!--              <p class="desc-text">不支持简历纠错</p>-->
<!--              <p class="desc-text">不支持制作证件照</p>-->
<!--              <p class="desc-text">可使用 1 次简历翻译功能</p>-->
<!--              <p class="desc-text">回收站简历 30 天可恢复</p>-->
<!--            </div>-->
<!--          </div>-->

<!--          <button class="btn" @click="improvedOrder">立即升级</button>-->

<!--        </div> &ndash;&gt;-->
<!--      </div>-->

      <!-- <div class="box groupon_member2x" v-if="alertData.show && alertData.type === 'upVip'">
        <img src="https://files.wondercv.com/member2x_background.png" width="100%" class="pic">
        <div class="qr-code" id="qrcode"></div>
      </div> -->


      <!-- 简历模板-查看弹窗 -->
      <div class="box job" v-if="alertData.show && alertData.type === 'job'">
        <img :src="alertData.jobImage || jobImage" alt="">
        <div class="job-cover"></div>
        <button @click="useTemplate()">
          <i class="el-icon-loading" v-if="useStateShow"></i>
          <span>使用模板</span>
        </button>
        <div class="clear">
          <i class="iconfont iconx-circle" @click="closeJob"></i>
        </div>
      </div>

      <!-- 导入简历 -->
      <div class="box import-resume" v-if="alertData.show && alertData.type === 'import'">
        <template v-if="!showPercentege">
          <div class="tips">
            <p class="title">拖拽简历到此区域</p>
            <p class="msg">支持Word、PDF、PNG或JPG等格式文件</p>
          </div>
              <!-- :data="uploadQuery" -->
          <el-upload
              class="upload-demo"
              :on-success="upSuccess"
              :on-progress="upProgress"
              :before-upload="beforeUpload"
              :action="uploadUrl"
              :show-file-list="false"
              :with-credentials="true"
              :headers="headers"
              :http-request="uploadIngFile"
              :drag="true"
          >
            <button>上传简历</button>
          </el-upload>
        </template>
        <div class="uploading" v-if="showPercentege">
          <img :src="`https://files.wondercv.com/uploading-icon-${uploading.type}.png`" alt="" class="uploading-icon">
          <div class="file flex-c">
            <div class="name flex1 color_40 ellipsis">{{uploading.fileName}}</div>
            <div class="percentage f_14">{{percentage}}%</div>
          </div>
          <el-progress style="width: 100%;" :stroke-width="8" :percentage="percentage" :show-text="false"/>
        </div>

      </div>
      <!-- 登陆弹窗--未完成 -->
      <div class="box login" v-if="alertData.show && alertData.type === 'login'">
        <p class="msg">微信扫码 快速登陆</p>
        <div class="sign">其他注册方式</div>
      </div>

      <!-- 模拟面试 -->
      <MockInterview v-if="alertData.show && alertData.type === 'mock-interview'" @close="close"></MockInterview>
    </transition>
    <!-- 局部组件 -->
    <inbox/>
    <share/>
    <message/>
    <portrait v-if="alertData && alertData.show"/>
    <privacy/>
    <school/>
  </div>
</template>
<script>
  import {mapState} from 'vuex';
  import {dealSignatrue, routerTo, getUserInfo, checkJWT} from '@/assets/js/util';
  import {TEMPLATE_IMAGES, FOREVER_PRICE} from '@/assets/js/const';
  import api from '@/api';

  import template from '@/assets/json/template';
  import inbox from './inbox';
  import share from './share';
  import message from './message';
  import portrait from './portrait';
  import privacy from './privacy';
  import school from './school';
  import ComponentAiCvsDialog from './ai-cvs.vue'
  import MockInterview from './mockInterview.vue';
  import payAlert from "@/views/account/user/payAlert";
  import { get_tUser } from '../../assets/js/util'

  let run = '';
  export default {
    name: 'sidebarAlert',
    components: {
      inbox,
      share,
      message,
      portrait,
      privacy,
      school,
      payAlert,
      ComponentAiCvsDialog,
      MockInterview
    },
    data() {
      return {
        FOREVER_PRICE,
        images: TEMPLATE_IMAGES,
        score: '',
        grade: '',
        result: 0,
        jobImage: '',
        jobToken: '',
        jobType: 'cn',
        isUseTemplate: true,
        templateCvToken: '',
        uploadQuery: {
          "source": 'pc_vue'
        },
        uploadUrl: (process.env.NODE_ENV == 'development' ? '/api' : process.env.API_ROOT) + '/v3/cvs/imports',
        percentage: 0,
        showPercentege: false, //上传简历状态
        uploading:{
          fileName:'',
          type: '', //上传文件的icon
        },
        templateCvs: [],

        qrcodeObj: {}, //生成活动二维码的参数
        headers: {
          'Access-Control-Allow-Origin': '*',
          'authorization': getUserInfo().authorization
        },
        useStateShow: false,
        hideImprovedOrderList:['MemberPayment'],
        hideImprovedOrder: false, //是否隐藏升级会员-立即升级按钮
        checkMemberType: ['cvCardCopy', 'cvImport', 'cvMerge', 'cvCheck'],  // 会员引导弹窗显示来源
      }
    },
    computed: {
      ...mapState('me', ['isLogin', 'publicKey', 'personInfo']),
      ...mapState('app', ['alertData']),
      templates() {
        return template
      }
      //...mapState('cvs', ['templates'])
    },
    created(){},
    watch: {
      'alertData.type': {
        handler(value) {
          // if(value === 'upVip' && this.alertData.show){
          //   this.createQrCode();
          // }
          let { name } = this.$route;
          // 是否隐藏升级会员-立即升级按钮
          this.hideImprovedOrder = this.hideImprovedOrderList.includes(name);

          if (value === 'template') {
            this.isTemplate = true;
          }
        },
        immediate: true,
        deep: true
      },
      'alertData.show': {
        handler: async function (show) {
          // if(value === 'upVip' && this.alertData.show){
          //   this.createQrCode();
          // }
          if (!show) {
            document.body.style.position = 'initial'
            document.body.style.overflow = 'initial'
            return false;
          }else{
            document.body.style.position = 'static'
            document.body.style.overflow = 'hidden'
          }

          let authorization = await getUserInfo();
          this.headers = {
            'Access-Control-Allow-Origin': '*',
            'authorization': authorization.Authorization
          }
        },
        immediate: true,
        deep: true
      },

    },
    methods: {
      // 跳转到简历模板页面
      toMoreTemplateFunc () {
        routerTo('/jianlimoban/', '_blank')
      },
      close() {
        this.templateCvToken = ''
        this.$store.dispatch('app/setAlertDataShow', false);
      },
      transform() {
        let reg = /^(\d{1,}\.\d+)|(\d+)$/;
        if (!reg.test(this.score) || !reg.test(this.grade)) {
          this.$message.error('输入有误！');
          return false;
        }
        let result = this.grade / this.score * 4;
        result = result > 4 ? 4 : result;
        this.result = result;
      },
      async beforeUpload(res) {
        console.log('res=>>',res)
        let { name, type } = res;
        type = type.toLowerCase();
        if(type.includes('pdf')){
          this.uploading = {
            fileName : name,
            type: 'pdf'
          }
        }else if(type.includes('word')){
          this.uploading = {
            fileName : name,
            type: 'pdf'
          }
        }else if(type.includes('png')){
          this.uploading = {
            fileName : name,
            type: 'png'
          }
        }else if(type.includes('jpg') || type.includes('jpeg')){
          this.uploading = {
            fileName : name,
            type: 'jpg'
          }
        }else{
          this.uploading = {
            fileName : name,
            type: 'file'
          }
        }
        this.uploadQuery = {source: process.env.CLIENT, file_name: res.name};
        this.showPercentege = true;
        return false
      },
      //上传简历
      uploadIngFile(f){
        let data = new FormData(); //创建form对象
        data.append('file',f.file);//通过append向form对象添加数据
        data.append('source',this.uploadQuery.source);//通过append向form对象添加数据
        data.append('file_name',this.uploadQuery.file_name);//添加form表单中其他数据
        run = setInterval(() => {
          if(this.percentage>=90){
            clearInterval(run)
            return
          }
          this.percentage = this.percentage+10;
        }, 100);
        api.cvsV3.uploadResume(data).then(res=>{
          clearInterval(run)
          this.percentage = 100;
          this.upSuccess(res)
        })
      },
      upSuccess(res) {
        if (res.code === 1000) {
          this.$message.success('导入成功');
          this.close();
          setTimeout(() => {
            routerTo(`/cvs/${res.data.cv_token}/editor`);
          }, 300);
        } else if (res.code === 3001) {
          this.$message.error(res.message);
          this.$store.dispatch('app/setAlertData', {
            show: true,
            type: 'upVip',
            browseType: 'cvImport'
          })
        } else {
          this.$message.error(res.message);
        }
        this.showPercentege = false;
        this.percentage = 0;
        this.uploading = {
          fileName : '',
          type: ''
        }
      },
      upProgress(res) {
        if (!run && ~~res.percent > 80) {
          this.percentage = 80;
          run = setTimeout(() => {
            this.percentage = 100;
          }, 1100)
        } else {
          this.percentage = ~~res.percent;
        }
      },
      selectTemplate(token, img, type, templateCvToken) {
        this.$store.dispatch('app/setAlertDataType', 'job');
        this.jobImage = img;
        this.jobToken = token;
        this.jobType = type;
        this.templateCvToken = templateCvToken;
        if (this.alertData.cvsType && this.alertData.cvsType != '') {
          this.isUseTemplate = this.alertData.cvsType === type ? true : false;
        } else {
          this.isUseTemplate = true
        }
      },
      closeJob() {
        this.templateCvToken = ''
        if (this.isTemplate) {
          this.$store.dispatch('app/setAlertDataType', 'template');
        } else {
          this.close();
        }
      },
      async useTemplate() {
        if (!this.isLogin) {
          routerTo('/signin?type=login');
          return false;
        } else if (!this.useStateShow) {
          let token = ''
          if (this.templateCvToken === '') {
            token = this.alertData.jobToken
          } else {
            token = this.templateCvToken
          }
          let { c_t } = get_tUser()
          this.useStateShow = true
          let res = await api.cvsEditor.canCreateCv(c_t)
          if (res.code === 1000) {
	          this.useStateShow = false
	          if (res.data[`can_create_${ this.jobType }_cv`]) {
		          this.$store.dispatch('app/setAlertData', { show: false })
		          window.location.href = `${ window.location.origin }/cvs/${ token }/editor`
            } else {
	          	if (this.personInfo.is_membership) {
	          		this.$message.error('已达简历数量上限')
              } else {
			          this.$store.dispatch('app/setAlertDataShow', false);
			          this.$message.error('已达简历上限，升级会员可创建多份简历');
			          setTimeout(() => {
				          this.$store.dispatch('app/setAlertData', {show: true, type: 'upVip', browseType: 'useTemplate'});
			          }, 300);
              }
            }
          } else {
          	this.useStateShow = false
          	console.log('接口报错')
          }
        }
      },
      async improvedOrder() {
        routerTo(`/account/users/buy_member`);
        // let params = await dealSignatrue({client: process.env.CLIENT});
        // await api.me.orderCreateByMembership(params)
        //   .then(res => {
        //     if (res.status === 1) {
        //       routerTo('/orders/' + res.data.order_token);
        //     }
        //   })
      },
      routerTo(path) {
        routerTo(path)
      },
      // 创建活动二维码
      createQrCode() {
        setTimeout(() => {
          if (document.getElementById("qrcode")) {
            let url = window.location.origin;
            this.qrcodeObj = new QRCode('qrcode', {
              text: `${url}/activity/groupon_calendar/member2x/?publicKey=${this.publicKey || ''}`,
              width: 152,
              height: 152,
              colorDark: '#000', // 绿色
              colorLight: '#fff',
              correctLevel: QRCode.CorrectLevel.H
            });
          }
        }, 100);
      },


    }
  }
</script>
<style lang="scss" scoped>
  .alert-main {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;

    .box {
      position: fixed;
      left: 0;
      right: 0;
      margin: auto;
    }

    .template {
      width: 824px;
      top: 50%;
      transform: translateY(-50%);
      padding: 32px 32px 24px;
      background: #FFFFFF;
      border-radius: 8px;
      box-sizing: border-box;
      height: 478px;

      .menu-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;

        .menu {
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 178px;
          background: #FFFFFF;
          border-radius: 8px;
          border: 1px solid #ECECEC;
          box-sizing: border-box;
          padding: 20px 0 24px;
          cursor: pointer;

          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4) {
            margin-bottom: 16px;
          }

          &:hover {
            border-color: #ffffff;
            box-shadow: 0px 2px 12px 0px rgba(25, 44, 81, 0.1);

            .btn {
              display: flex;
            }

          }

          >img {
            width: 52px;
            height: 52px;
            margin-bottom: 12px;
          }

          >p {
            text-align: center;
            padding: 0 14px;
          }

          .title {
            font-size: 15px;
            font-weight: 500;
            color: #404040;
            line-height: 21px;
            margin-bottom: 5px;
          }

          .desc {
            font-size: 12px;
            font-weight: 400;
            color: #9C9C9C;
            line-height: 17px;
          }

          .btn {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: none;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #FFFFFF;

            >button {
              width: 154px;
              height: 35px;
              color: #FF6644;
              background: #ffffff;
              font-size: 13px;
              font-weight: 400;
              line-height: 27px;
              padding: 0;
              border-radius: 4px;
              border: 1px solid #FF6644;
              box-sizing: border-box;

              &:hover {
                color: #fff;
                background: #FF6644;
              }
              &:nth-child(2) {
                margin-top: 6px;
              }
              &:last-child{
                margin-left: 0;
              }

            }
          }

        }
      }

      .template-more-btn {
        width: 240px;
        height: 40px;
        border-radius: 6px;
        border: 1px solid #ECECEC;
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        line-height: 38px;
        margin: 24px auto 0;
        text-align: center;
        box-sizing: border-box;
        cursor: pointer;

        &:hover {
          color: #ff6644;
          border-color: #ff6644;
        }
      }

    }

    .gpa {
      padding: 32px;
      box-sizing: 0 5px 15px rgba(0, 0, 0, 0.5);
      border-radius: 6px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      width: 534px;
      top: 50px;
      background: #fff;

      .close {
        font-size: 22px;
        color: #404040;
        position: absolute;
        top: 42px;
        right: 42px;
        cursor: pointer;
        font-weight: 600;
      }

      .title {
        font-size: 18px;
        font-weight: 600;
        color: rgb(64, 64, 64);
        margin-top: 10px;
        margin-bottom: 34px;
      }

      .msg {
        line-height: 28px;
      }

      .case {
        color: rgb(64, 64, 64);
        margin-top: 18px;
        margin-bottom: 28px;
        line-height: 28px;

        b {
          font-weight: 700;
        }
      }

      .info {
        font-size: 14px;
        display: flex;
        justify-content: space-between;

        input {
          width: 153px;
          height: 40px;
          padding: 0 18px;
          border: 1px solid #DEDFE1;
          outline: none;
          border-radius: 2px;

          &:focus {
            border-color: #ff4f4c;
          }
        }

        button {
          width: 86px;
          height: 42px;
          background: #ff4f4c;
          color: #fff;
          border-radius: 4px;
        }
      }

      .result {
        font-size: 16px;
        color: rgb(64, 64, 64);
        margin-top: 24px;

        b {
          font-size: 18px;
          font-weight: 600;
        }
      }
    }

    .applets {
      width: 338px;
      height: 362px;
      background: #fff;
      text-align: center;
      top: 50px;
      border-radius: 6px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);

      .title {
        margin-top: 36px;
        margin-bottom: 24px;
        font-size: 24px;
      }

      img {
        width: 180px;
        height: 180px;
        margin: auto;
      }

      .msg {
        margin-top: 34px;
        color: #909090;
        font-size: 14px;
      }
    }

    .up-vip {
      width: 598px;
      // height: 400px;
      // background: #fff;
      border-radius: 8px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
      top: calc(50% - 20px);
      transform: translateY(-50%);
      overflow: hidden;

      .vip-bg {
        width: 100%;
      }

      .vip-btn {
        position: absolute;
        bottom: 28px;
        left: 50%;
        transform: translateX(-50%);
        padding: 9px 70px;
        background: linear-gradient(133deg, #FCE6CF 0%, #EABC92 100%);
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        color: #1D2036;
        letter-spacing: 1px;

        &:hover {
          opacity: 0.8;
        }
      }

      .title {
        width: 100%;
        height: 92px;
        background-color: #32363E;
        //margin-top: 34px;
        //margin-bottom: 10px;
        font-size: 14px;
        line-height: 33px;
        color: #FFFFFF;
        text-align: center;
        position: relative;
        // background-image: url("../../assets/image/member_alert_background.png");
        background-size: 100% 100%;
        overflow: hidden;

        .super-logo{
          height: 20px;
          position: absolute;
          left: 50%;
          top: 24px;
          transform: translateX(-50%);
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 42px;
            height: 18px;
          }
          span {
            color: #fff;
            font-size: 20px;
            font-weight: bold;
            margin-left: 8px;
          }
        }

        p {
          position: absolute;
          left: 50%;
          bottom: 22px;
          height: 22px;
          color: #FFFFFF;
          transform: translateX(-50%);
        }

        .vip-bg {
          position: absolute;
          right: 0;
          bottom: -18px;
          width: 173px;
        }

      }

      .msg {
        font-size: 14px;
        color: #909090;
        position: relative;
        text-align: center;

        &::before,
        &::after {
          content: "";
          display: block;
          width: 144px;
          height: 1px;
          background: #909090;
          position: absolute;
          top: 50%;
          left: 75px;
        }

        &::after {
          left: auto;
          right: 75px;
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #414653;

        .desc {
          width: 472px;
          display: flex;
          margin-top: 28px;

          .desc-item {
            flex: 1;

            .desc-title {
              font-size: 16px;
              font-weight: 600;
              line-height: 16px;
              padding: 12px 0;
              text-align: center;
              border-radius: 6px 6px 0px 0px;

              >img {
                display: inline-block;
                width: 16px;
                margin-right: 4px;
              }

            }

            .desc-text {
              font-size: 14px;
              font-weight: 400;
              line-height: 14px;
              height: 34px;
              line-height: 34px;

              .strong {
                font-weight: 500;
              }

              .iconfont {
                color: #FF6644;
                font-size: 16px;
                margin-right: 14px;
              }

            }
          }

          .desc-left {
            .desc-title {
              color: #7A5C40;
              background: #EABC92;
            }

            .desc-text {
              color: #7A5C40;
              padding-left: 22px;

              &:nth-last-of-type(2n + 1) {
                background: #FCE6CF;
              }

              &:nth-last-of-type(2n) {
                background: #F3D6BA;
              }

              &:last-of-type {
                border-radius: 0px 0px 0px 6px;
              }

            }
          }

          .desc-right {
            .desc-title {
              color: #959595;
              background: #EEEEEE;
            }

            .desc-text {
              color: #A3A3A3;
              text-align: center;

              &:nth-last-of-type(2n + 1) {
                background: #FFFFFF;
              }

              &:nth-last-of-type(2n) {
                background: #F7F7F7;
              }

              &:last-of-type {
                border-radius: 0px 0px 6px 0px;
              }

            }
          }

        }

        .btn {
          padding: 9px 70px;
          background: linear-gradient(133deg, #FCE6CF 0%, #EABC92 100%);
          border-radius: 4px;
          font-size: 16px;
          font-weight: 500;
          color: #582F1D;
          line-height: 22px;
          letter-spacing: 1px;
          margin-top: 26px;
          margin-bottom: 28px;
        }



        .qrcode {
          color: #404040;
          img {
            width: 182px;
            height: 182px;
            margin: 36px auto 28px;
          }

          p {
            font-size: 16px;
            text-align: center;
          }
        }
      }
    }

    .groupon_member2x {
      width: 600px;
      height: 400px;
      background: #fff;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
      top: 80px;
      border-radius: 8px;

      .pic {
        display: block;
        width: 100%;
      }

      .qr-code {
        position: absolute;
        top: 88px;
        right: 88px;
        width: 152px;
        padding: 10px;
      }
    }

    .job {
      width: 500px;
      height: 680px;
      top: 80px;

      img {
        width: 100%;
        height: 100%;
        position: relative;
        z-index: 1;
      }

      .job-cover {
        width: 100%;
        height: 100%;
        background: #fff;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        opacity: 0;
      }

      button {
        display: none;
        width: 120px;
        height: 36px;
        border-radius: 2px;
        background: #ff6644;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        z-index: 3;
        opacity: 1;
        border-radius: 4px;
        .el-icon-loading {
          margin-right: 6px;
        }
      }

      &:hover {
        .job-cover {
          opacity: .3;
        }

        button {
          display: block;
        }
      }

      .clear {
        position: absolute;
        top: -45px;
        right: 0px;
        color: #fff;

        .iconfont {
          font-size: 24px;
          font-weight: 900;
          cursor: pointer;
        }

        &::after {
          content: "";
          display: block;
          width: 2px;
          height: 40px;
          background: #fff;
          position: absolute;
          left: 50%;
          bottom: -37px;
          margin-left: -1px;
        }
      }
    }

    .import-resume {
      top: 20vh;
      width: 600px;
      height: 332px;
      background: #fff;
      border-radius: 6px;
      border: 1px solid #DEDFE1;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      text-align: center;
      .tips{
        width: 512px;
        height: 170px;
        background: #F9F9F9;
        border-radius: 6px;
        border: 2px dashed #CFCFCF;
        margin: 44px auto;
        .title {
          font-size: 18px;
          color: #404040;
          margin-top: 56px;
          line-height: 22px;
          font-weight: bold;
        }

        .msg {
          color: #9c9c9c;
          margin-bottom: 24px;
          margin-top: 16px;
        }
      }
      button {
        width: 118px;
        height: 34px;
        line-height: 33px;
        background: #50a4ff;
        border-radius: 2px;
        color: #fff;
        font-size: 14px;
      }

      .upload-demo{
        width: 600px;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: transparent;
        ::v-deep .el-upload{
          width: 100%;
          height: 100%;
          .el-upload-dragger{
            width: 100%;
            height: 100%;
            background-color: transparent;
            border: none;
            button{
              margin-top: 250px;
              width: 207px;
              height: 46px;
              background: #4183FF;
              border-radius: 4px;
              font-size: 16px;
              &:hover{
                background: #669BFF;
              }
            }
          }
        }
      }
      .uploading{
        width: 446px;
        margin: 70px auto 0;
        &-icon{
          width: 68px;
          height: 88px;
          display: block;
          margin: 0 auto;
        }
        .file{
          height: 18px;
          line-height: 18px;
          font-size: 16px;
          margin: 64px 0 15px;
          .name{
            font-weight: bold;
            margin-right: 50px;
            text-align: left;
          }
          .percentage{
            color: #bcbcbc;
          }
        }
      }
    }

    .login {
      width: 400px;
      height: 400px;
      top: 80px;
      border-radius: 6px;
      background: #fff;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
      text-align: center;

      .msg {
        font-size: 14px;
      }

      .sign {
        font-size: 13px;
        color: #a1a1a1;
        cursor: pointer;
      }
    }
  }
</style>
